import React, { useCallback } from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';
import { FaInfoCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';

function ControlNode({ data, isConnectable, selected, width, height }) {

  const onChange = useCallback(
    (e) => {
      data.value = e.target.value;
    },
    [data],
  );

  React.useEffect(() => {
    if (!data.startingWidth){
      data.startingWidth = width;
    }
  }, []);

  return (
    <div className="conversation-canvas-node conversation-canvas-node--category" style={{height: height || 'auto'}}>
      <NodeResizer
      maxWidth={500}
      minHeight={108}
      minWidth={data.startingWidth}
      isVisible={selected && !data.hasOwnProperty('locked')}
      color='#3ab54a'
      handleStyle={{width:'10px', height:'10px'}}
      />
      <Handle
        type="source"
        position={Position.Top}
        id="control-target"
        isConnectable={isConnectable}
        className="conversation-canvas-node__handle conversation-canvas-node__handle--category"
      />
      <div className="conversation-canvas-node__title conversation-canvas-node__title--category">
        <div className="conversation-canvas-category-node-title-text">
          {data.title}{' '}
          <span className="conversation-canvas-category-node-info-icon" title="Click for more information about Topics">
            <FaInfoCircle size={16} color="#FFFFFF" />
          </span>
        </div>
      </div>
      <div className="conversation-canvas-node-content">
        <div>
          <textarea
            className="conversation-canvas-node-content__input nodrag"
            id="text"
            name="text"
            maxLength="500"
            onChange={onChange}
            defaultValue={data.value}
            readOnly={data.locked}
            style={{
              width: width - 16,
              minWidth: width - 16,
              height: height - 57 || 'auto',
              minHeight: height - 57 || 'auto',
              resize: 'none',
            }}
          ></textarea>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Left}
        id="control-source-left"
        isConnectable={isConnectable}
        className="conversation-canvas-node__handle conversation-canvas-node__handle--category"
      />
      <Handle
        type="source"
        position={Position.Right}
        id="control-source-right"
        isConnectable={isConnectable}
        className="conversation-canvas-node__handle conversation-canvas-node__handle--category"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="control-source"
        isConnectable={isConnectable}
        className="conversation-canvas-node__handle conversation-canvas-node__handle--category"
      />
    </div>
  );
}

export default ControlNode;

ControlNode.propTypes = {
  data: PropTypes.object,
  isConnectable: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  width: PropTypes.any,
  height: PropTypes.any
}